var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRewardLineupIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1v3h2V1H4zm13 4h-4V3H7v2H3V3H1v3h18V3h-2v2zm-3-1V1h2v3h-2zm5 3H1v12h18V7zM5 11V9H3v2h2zm-2 3v-2h2v2H3zm2 3v-2H3v2h2zm2-8h2v2H7V9zm2 3H7v2h2v-2zm-2 3h2v2H7v-2zm6-6h-2v2h2V9zm2 2V9h2v2h-2zm-2 1h-2v2h2v-2zm2 2v-2h2v2h-2z",
    fill: "#9A9CAC"
  })));
}

export default SvgRewardLineupIcon;